import { styles } from './global.styles';

export default function AppStyles() {
  return <style jsx global>{styles}</style>;
}
